import { render, staticRenderFns } from "./SetEventOutcomeAndNote.vue?vue&type=template&id=123ff07c&scoped=true"
import script from "./SetEventOutcomeAndNote.vue?vue&type=script&lang=ts"
export * from "./SetEventOutcomeAndNote.vue?vue&type=script&lang=ts"
import style0 from "./SetEventOutcomeAndNote.vue?vue&type=style&index=0&id=123ff07c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123ff07c",
  null
  
)

export default component.exports